import axios from "axios";

const axiosInstance = axios.create({
    baseURL: "https://lws-server.herokuapp.com/",
});

export default axiosInstance;
